export default "<div id=groupMoldDistributionChart> <canvas id=chart width=\"{{vm.width}}\" height=\"{{vm.height}}\"></canvas> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/counts/equipmentGroupMoldDistributionGraph.tpl.html
// module id = 521
// module chunks = 0